import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

interface AmexLogoProps extends IconProps {
  theme?: 'phthalo' | 'grayscale' | 'greenfit'
}

export const AmexLogo: FC<AmexLogoProps> = (props) => {
  const themeColors = (theme?: string) => {
    if (!theme) {
      return '#fff'
    }
    return theme === 'phthalo' ? '#ADEDD6' : theme === 'greenfit' ? '#B1F3A7' : '#fff'
  }

  return (
    <Icon width={59} height={15} fill="#ADEDD6" viewBox="0 0 59 15" {...props}>
      <path
        d="M6.616.194 0 14.787h7.92l.983-2.326h2.244l.982 2.326h8.718v-1.776l.777 1.776h4.51l.777-1.813v1.813h18.132l2.205-2.266 2.064 2.266 9.313.02-6.637-7.276L58.625.194h-9.168L47.31 2.418 45.311.194H25.586L23.892 3.96 22.158.194h-7.904v1.715L13.375.194H6.616ZM8.15 2.266h3.86l4.39 9.896V2.266h4.229l3.39 7.096 3.124-7.096h4.208v10.472h-2.56l-.022-8.206-3.733 8.206h-2.29L18.99 4.532v8.206h-5.267l-1-2.348H7.329l-.996 2.346H3.509l4.64-10.47Zm25.544 0h10.412l3.184 3.429 3.288-3.429h3.184L48.923 7.53l4.838 5.203h-3.329l-3.184-3.469-3.304 3.469H33.693V2.266ZM10.027 4.038 8.25 8.22h3.553l-1.776-4.182Zm26.237.396v1.912h5.68v2.13h-5.68v2.088h6.371l2.96-3.074-2.834-3.057h-6.497v.001Z"
        fill={themeColors(props.theme)}
      />
    </Icon>
  )
}
